<template>
  <b-dropdown aria-role="list" class="collapsed-dropdown">
    <button class="button" slot="trigger" v-bind:class="{ active: active }">
      <span v-html="title" />
      <b-icon v-if="icon" icon="menu-down"></b-icon>
    </button>
    <b-dropdown-item
      aria-role="listitem"
      v-for="(item, index) in info"
      :key="index"
      :href="item.url"
    >
      {{ item.label }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  name: "Dropdown",
  data() {
    return {};
  },
  props: {
    active: Boolean,
    icon: Boolean,
    info: Array,
    title: String
  }
};
</script>

<style lang="scss">
.collapsed-dropdown {
  .button {
    background: transparent;
    border: none;
    color: inherit;
    font-size: inherit;
    &:hover {
      color: inherit;
    }
    &:focus {
      color: inherit;
    }
  }
  .dropdown-menu {
    padding-top: 0;
    .dropdown-content {
      padding: 0;
      background-color: $light-gray;
      a {
        padding: 0.25em 1em;
        border-bottom: 1px solid $grey-light;
        &:hover {
          background-color: $grey-lighter;
        }
        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}
</style>
